// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"PayButton_nowrap__3AsvI"};